export type AuthenticationResult = {
  accessToken?: string;
  expiresIn?: number;
  tokenType?: string;
  refreshToken?: string;
  idToken?: string;
}

export type ForgotPasswordRequest = {
  userId?: string;
}

export type ForgotPasswordResponse = {
  result?: ForgotPasswordResult;
  error?: string;
}

export enum ForgotPasswordResult {
  TEMP_PASSWORD_SENT = 'TEMP_PASSWORD_SENT',
  VERIFICATION_CODE_SENT = 'VERIFICATION_CODE_SENT'
}

export type LoginDto = {
  loginMode?: string;
  idpName?: string;
}

export type LoginRequest = {
  username?: string;
  password?: string;
}
